import React from 'react';
import Slider from 'react-slick';
import "util/font_style_module/fontStyle.css";
import Styles from "css/normal_css/normal_d.module.css";
import Styles2 from "css/landing_css/landing_m.module.css";
import { NavLink } from "react-router-dom";
import Image from "assets/point_assets/img.png";
import ScreenShot1 from "assets/landing_assets/l_screenShot_img.png";
import ScreenShot2 from "assets/landing_assets/l_screenShot2_img.png";
import ScreenShot3 from "assets/landing_assets/l_screenShot3_img.png";
import ScreenShot4 from "assets/landing_assets/l_screenShot4_img.png";

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: false,
  appendDots: dots => (
    <div
      style={{
        position: "absolute",
        bottom: "12px",
        left: "20px",
        right: "20px",
        width: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <ul style={{
        margin: "0",
        padding: "0",
        display: "flex",
        listStyle: "none",
        gap: "0px"
      }}>
        {dots}
      </ul>
    </div>
  ),
  customPaging: i => (
    <div
      style={{
        width: "8px",
        height: "8px",
        backgroundColor: "#E5E7EB",
        borderRadius: "50%",
        cursor: "pointer",
        opacity: 0.8,
        transition: "background-color 0.3s ease, border-color 0.3s ease",
      }}
    ></div>
  ),
  dotsClass: "slick-dots",
};

const CarouselPictureM = () => {
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <div style={{ width: "100%", maxWidth: "280px" }}>
        <Slider {...settings}>
          {[ScreenShot1, ScreenShot2, ScreenShot3, ScreenShot4].map((img, idx) => (
            <div key={idx} style={{ display: "flex", justifyContent: "center", justifyItems: "center", justifySelf: "center" }}>
              <img
                src={img}
                style={{
                  width: "256px",
                  height: "256px",
                  margin: "0 4px", // ← 좌우 간격을 여기서 조절!
                }}
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default CarouselPictureM;